module.exports = __webpack_public_path__ + "static/media/detected.11538184.JPG";